import { jsx as p } from "react/jsx-runtime";
import f from "next/link.js";
import u from "./Button.js";
const x = ({
  ariaLabel: t,
  children: e,
  className: r,
  href: n,
  isGhost: s,
  isWide: a,
  level: i = "primary",
  onClick: l,
  tabIndex: m,
  target: o
}) => /* @__PURE__ */ p(
  f,
  {
    "aria-label": t,
    className: u.styles({
      class: r,
      isGhost: s,
      isWide: a,
      level: i
    }),
    href: n,
    onClick: l,
    tabIndex: m,
    target: o,
    rel: o === "_blank" ? "noopener" : void 0,
    children: e
  }
);
export {
  x as default
};
